<template>
  <ReferenceMultipleSelect
    v-model="sendingCountries"
    class="ma-0"
    label="Страна отправления"
    resource="countries"
    @input="changeSendingCountries"
  />
</template>

<script>
export default {
  computed: {
    sendingCountries: {
      get() {
        return this.$store.getters["routePlanning/sendingCountries"];
      },
      set(value) {
        return this.$store.commit("routePlanning/setSendingCountries", value);
      },
    },
  },
  methods: {
    changeSendingCountries(value) {
      this.$store.commit("routePlanning/setSendingCountries", value);
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$emit("input");
    },
  },
};
</script>
